import React from 'react';

export const SettingsContext = React.createContext({
  settings: {},
  onSetSettings: () => null,
});
